import React from "react";
import EbookDownloads from "./EbookDownloads";
import { Helmet, HelmetProvider } from "react-helmet-async";

import TrendsImg from "./PptImages/trends.svg";
import DigitalImg from "./PptImages/digital.svg";
import CompImg from "./PptImages/competition.svg";
import BankImg from "./PptImages/bank-euro.svg";
import BrainImg from "./PptImages/brain.svg";
import VirImg from "./PptImages/vir.svg";

import "./immobilienverwaltung.css";

export default function Immobilienverwaltung() {
	return (
		<>
			<HelmetProvider>
				<Helmet>
					<title>
						Digitalisierungs- und Prozessberatung für die Immobilienwirtschaft
					</title>
					<meta
						name="description"
						content="	Digitalisierungs- und Prozessberatung für die Immobilienwirtschaft"
					/>
					<meta
						name="keywords"
						content="Digitalisierungs, Prozessberatung, Immobilienwirtschaft, Feingeist, Berlin"
					/>
				</Helmet>
			</HelmetProvider>
			<div className="beratung_cont" id="property_management">
				<h1>
					Digitalisierungs- und Prozessberatung für die Immobilienwirtschaft
				</h1>
				<hr />
				<h2 className="py-2">Die Herausforderungen</h2>

				<div className="row digit-cards-container">
					<div className="col-md-3 m-2 digit-contain">
						<div className="flex flex-row digit-cards">
							<h5 className="digit-card-head">
								Globale Trends
								<img src={TrendsImg} className="digit-card-img" />
							</h5>
							<p className="digit-card-desc">
								Die Immobilienbranche ist stark von globalen Trends beeinflusst.
								Zunehmende Urbanisierung, veränderte Lebensentwürfe und der
								Fokus auf Nachhaltigkeit prägen die Anforderungen an die
								Immobilienverwaltung.
							</p>
						</div>
					</div>
					<div className="col-md-3 m-2 digit-contain">
						<div className="flex flex-row digit-cards">
							<h5 className="digit-card-head">
								Digitalisierung
								<img src={DigitalImg} className="digit-card-img" />
							</h5>
							<p className="digit-card-desc">
								Die Digitalisierung verändert die Immobilienbranche grundlegend.
								Prozesse werden automatisiert, neue Technologien wie künstliche
								Intelligenz und Big Data werden eingesetzt, und die Interaktion
								mit Kunden findet zunehmend digital statt.
							</p>
						</div>
					</div>
					<div className="col-md-4 m-2 digit-contain">
						<div className="flex flex-row digit-cards">
							<h5 className="digit-card-head">
								Wettbewerbslandschaft
								<img src={CompImg} className="digit-card-img" />
							</h5>
							<p className="digit-card-desc">
								Der Wettbewerb in der Immobilienverwaltung ist stark. Neue
								Anbieter drängen auf den Markt, und etablierte Unternehmen
								setzen verstärkt auf innovative Lösungen.
							</p>
						</div>
					</div>
					<div className="col-md-3 m-2 digit-contain ">
						<div className="flex flex-row digit-cards">
							<h5 className="digit-card-head">
								Pandemie und Gesetzgebung
								<img src={VirImg} className="digit-card-img" />
							</h5>
							<p className="digit-card-desc">
								Die Pandemie hat die Immobilienverwaltung beeinflusst. Die
								Anpassung gesetzlicher Rahmenbedingungen, beispielsweise bei
								Mietverträgen, stellt eine Herausforderung dar. Auch
								ESG-Anforderungen und die Erwartungen der Generation Z an die
								Arbeitswelt müssen beachtet werden.
							</p>
						</div>
					</div>
					<div className="col-md-3 m-2 digit-contain">
						<div className="flex flex-row digit-cards">
							<h5 className="digit-card-head">
								Marktentwicklung
								<img src={BankImg} className="digit-card-img" />
							</h5>
							<p className="digit-card-desc">
								Die Preissteigerungen in der Immobilienbranche stellen eine
								erhebliche Herausforderung dar. Der Verwaltungsaufwand nimmt zu,
								während die Personalkosten steigen. Sowohl der Fachkräftemangel
								als auch die flexible Arbeitswelt müssen berücksichtigt werden.
							</p>
						</div>
					</div>
					<div className="col-md-4 m-2 digit-contain">
						<div className="flex flex-row digit-cards">
							<h5 className="digit-card-head">
								Mensch & Maschine
								<img src={BrainImg} className="digit-card-img" />
							</h5>
							<p className="digit-card-desc">
								Die Gestaltung der Mensch-Maschine-Schnittstelle ist von
								entscheidender Bedeutung. Die Arbeitsumgebung muss an neue
								Anforderungen angepasst werden. Der Führungsstil sollte die
								veränderten Bedürfnisse der Mitarbeiter berücksichtigen.
							</p>
						</div>
					</div>
				</div>

				<p>
					<em>Wie helfen der Immobilienwirtschaft in die Zukunft.</em>
				</p>
				<p>
					Die Feingeist Beratung unterstützt sie auf dem Weg in die
					Digitalisierung, bei der Strukturierung der Prozesse sowie bei der
					strategischen Ausrichtung.
				</p>
				<h2>Ihre Vorteile:</h2>
				<ul className="typeset-u-list">
					<li>Starkes Beratungsteam mit jahrelanger Branchenerfahrung</li>
					<li>Umfangreiche Projekthistorie</li>
					<li>Analysetools auf die Branche zugeschnitten</li>
					<li>Synergieeffekte aus der Transaktions- und Prozessberatung</li>
				</ul>
				<p>
					Die Immobilienwirtschaft bzw. die Immobilienverwaltungsbranche ist im
					Umbruch. Neben dem Thema Personal ist die Digitalisierung die
					Herausforderung der nächsten Jahre.
				</p>
				<p>
					Die Feingeist Beratung unterstützt Sie mit einem erfahrenen Team bei
					folgenden Herausforderungen:
				</p>
				<ul className="typeset-u-list">
					<li>Fehlende strategische Ausrichtung</li>
					<li>Keine Digitalisierungsstrategie</li>
					<li>Nicht funktionierende oder keine Prozesse</li>
					<li>Hohe Belastungsspitzen und Rückstand</li>
					<li>Übergabe bzw. Nachfolge unklar bzw. nicht organisiert</li>
					<li>Unübersichtliche Messdienstleistungen</li>
					<li>Kein Personal und hohe Fluktuation</li>
					<li>Keine Begleitung bei der Digitalisierung</li>
				</ul>
				<p>
					Mit unseren Analysetools für die Branche können wir Sie individuell zu
					Ihrem Zielbild begleiten.
				</p>
				<p>Sprechen Sie uns an.</p>
				<p>
					<a
						className="description-link"
						onClick={(e) => document.getElementById("ebookdownloads").click()}
					>
						Beratungsprodukte
					</a>
				</p>
			</div>
		</>
	);
}
